module.exports = __webpack_public_path__ + "img/88_musicterm.4f3e4daa.jpg";